import { httpGet, httpPost, httpDelete } from "@/request/http";
import func from "@/funcs";

let path = "/foods";

export default {
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  getNames() {
    return httpGet(`${path}/names`);
  },
  getName(id) {
    return httpGet(`${path}/names/${id}`);
  },
  getNamePages(dTO) {
    return httpPost(`${path}/pages/names`, dTO);
  },
  getNamesByKind(id) {
    return httpGet(`/foodkinds/${id}/${path}/names`);
  },
  getPages(dTO) {
    return httpPost(`${path}/pages`, {
      ...dTO,
      IsFilterByEmployeeSupplier: true,
    });
  },
  save(item) {
    return httpPost(path, item);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
  getSequencesByKind(moduleId, foodKindId, dTO) {
    return httpGet(
      `/modules/${moduleId}/foodkinds/${foodKindId}/foods/sequences`,
      dTO
    );
  },
  before(moduleId, foodId, pageSize) {
    return httpPost(`/modules/foods/sequences/before`, {
      moduleId,
      foodId,
      pageSize,
    });
  },
  after(moduleId, foodId, pageSize) {
    return httpPost(`/modules/foods/sequences/after`, {
      moduleId,
      foodId,
      pageSize,
    });
  },
  position(dTO) {
    return httpPost(`/modules/foods/sequences/position`, dTO);
  },
  getByNumber(number) {
    return httpGet(`${path}/number/${number}`);
  },
  getByNumberOrKeyword(keyword) {
    return httpGet(`${path}/number/${keyword}`)
      .then((food) => [food])
      .catch((error) => {
        if (error.status !== 404) throw error;
        return httpPost(`${path}/keyword`, {
          Keyword: keyword,
          IsFilterByEmployeeSupplier: true,
        });
      });
  },
  getExcel(dTO) {
    func.getExcel.get(`${path}/excel`, "商品", dTO);
  },
  postExcel(formData, showSuccessMessage = true) {
    return func.postExcel(
      `${path}/excel`,
      formData,
      600000,
      showSuccessMessage
    );
  },
  getImage(id) {
    return httpGet(`${path}/${id}/image`, null, { responseType: "blob" });
  },
  postImage(id, formData) {
    return httpPost(`${path}/${id}/image`, formData);
  },
  getFoodImages(id) {
    return httpGet(`${path}/${id}/image-paths`);
  },
  postFoodImages(id, items) {
    return httpPost(`${path}/${id}/images`, items);
  },
  postImages(items) {
    return httpPost(`${path}/images`, items);
  },
  deleteImage(id) {
    return httpDelete(`${path}/${id}/image`);
  },
  getNextNumber(number) {
    return httpGet(`${path}/number/${number}/nextnumber`);
  },
  getByKeyword(item) {
    return httpPost(`${path}/keyword`, {
      ...item,
      IsFilterByEmployeeSupplier: true,
    });
  },
  getCasio(warehouseId) {
    func.getTXT.get(`/warehouses/${warehouseId}/casio/foods`, "product");
  },
  getTYSSO(warehouseId) {
    func.getTXT.get(`/warehouses/${warehouseId}/tysso/foods`, "product");
  },
  postDigiwinExcel(formData, showSuccessMessage = true) {
    return func.postExcel(
      `${path}/digiwin/excel`,
      formData,
      600000,
      showSuccessMessage
    );
  },
  getIsBarcodeExist(foodId, barcode) {
    return httpGet(`${path}/${foodId}/barcode/${barcode}/exist`);
  },
  getStock(warehouseId, foodId) {
    return httpGet(`${path}/stock`, { warehouseId, foodId });
  },
  getStockByNumber(warehouseNumber, foodId) {
    return httpGet(`${path}/stock`, { warehouseNumber, foodId });
  },
  getSpecification(specificationtypeId) {
    return httpGet(`/specificationtypes/${specificationtypeId}`);
  },
  saveSpecification(items) {
    return httpPost(`/specificationtypes`, items);
  },
  removeSpecification(specificationtypeId) {
    return httpDelete(`/specificationtypes/${specificationtypeId}`);
  },
  getFoodSpecifications(foodId) {
    return httpGet(`${path}/${foodId}/specifications`);
  },
  saveFoodSpecifications(foodId, items) {
    return httpPost(`${path}/${foodId}/specifications`, items);
  },
  getFoodBrands(foodId) {
    return httpGet(`/foodBrands/${foodId}`);
  },
  saveFoodBrands(items) {
    return httpPost(`/foodBrands`, items);
  },
  syncECPlatform(pathNoPlatform) {
    const ECPlatformType = parseInt(func.localStorage.get("ECPlatformType"));
    let platform = "";
    if (ECPlatformType === 1) platform = "showmore";
    else if (ECPlatformType === 2) platform = "meepshop";
    else if (ECPlatformType === 0) return Promise.resolve({ skipped: true });
    return pathNoPlatform
      ? httpPost(`/products/sync`)
      : httpPost(`/${platform}/products/sync`);
  },
  postDigiwin() {
    return httpPost(`/digiwin/foods/sync`);
  },
  getFoodGroups() {
    return httpGet(`/fookinds/group`);
  },
  changeMajorKind(id, majorKindId) {
    return httpPost(`/fookinds/${id}/change-majorkind/${majorKindId}`);
  },
  getFoodsByList(ids) {
    return httpPost(`${path}/list`, ids);
  },
  labelsPrint(items) {
    func.getTXT.post(`${path}/labels/print`, "標籤列印", items);
  },
};
